import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%","display":"flex","justify-content":"center","align-items":"center","padding":"40px 0"} }
const _hoisted_2 = { style: {"border":"none","display":"flex","align-items":"center","gap":"12px"} }

import { IonLabel, IonSpinner } from '@ionic/vue';

interface Props {
    isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicSpinner',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    isLoading: boolean;
};



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IonSpinner), { name: "crescent" }),
      _createVNode(_unref(IonLabel), { style: {"display":"block"} }, {
        default: _withCtx(() => [
          _createTextVNode("Loading..")
        ]),
        _: 1
      })
    ])
  ], 512)), [
    [_vShow, props.isLoading]
  ])
}
}

})